import { render } from "./Overview.vue?vue&type=template&id=0940dc40"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0940dc40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0940dc40', __exports__)) {
    api.reload('0940dc40', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=0940dc40", () => {
    api.rerender('0940dc40', render)
  })

}


export default __exports__